import React, { createContext, useContext, useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import Modal from '../Components/Modal';
import Button from '../Components/Button'
import {UserContext} from './UserContext'
  

const IdleTimerContext = createContext();

export const useIdleTime = () => {
  const context = useContext(IdleTimerContext);
  if (!context) {
    throw new Error('use idletimer issue');
  }
  return context;
};

export const IdleTimerProvider = ({ 
  children,
  timeout = 1000 * 60 * 2, // 2 mins before call logout
  warningTime = 1000 *  600, // 10 minute of idle time to warning
}) => {
  const [isWarning, setIsWarning] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(timeout);
  const [showModal, setShowModal] = useState(false);
  const { user, signOut } = useContext(UserContext);
  const excludedPaths = ['/', '/login', '/resetPassword', '/resetUserPassword']

  const onIdle = () => {
    console.log('user is idle')
    setShowModal(false);
    setIsWarning(false);
    if(user) {
       handleLogout();
    }   
  };

  const onActive = () => {
    setIsWarning(false);
    setShowModal(false);
  };

  const onPrompt = () => {
    if(!isExcludedPath) {
      console.log('prompt warning to user');      
      setIsWarning(true);
      setShowModal(true);  
    }
  };


  const { activate, deactivate, reset, getRemainingTime } = useIdleTimer({
    timeout,
    onIdle,
    onActive,
    onPrompt,
    promptBeforeIdle: timeout - warningTime,
    crossTab: {
      emitOnAllTabs: true,
    },
    syncTimers: 200
  });

  const isExcludedPath = excludedPaths.includes(location.pathname)


  useEffect(() => {
     //if(user && user.accountType != ''){
      const interval = setInterval(() => {
        setTimeRemaining(getRemainingTime());
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    //}
  }, [getRemainingTime]);

  const handleStayActive = () => {
    reset();
    setIsWarning(false);
    setShowModal(false);
  };

  const handleLogout = () => {
     
    console.log('handle logout')
    setIsWarning(false);
    setShowModal(false);
    signOut();
    //TODO verify login url
    window.location.href = "/"
  };

  const value = {
    isWarning,
    timeRemaining,
    showModal,
    onStayActive: handleStayActive,
    onLogout: handleLogout,
    activate,
    deactivate,
    reset
  };

  return (
    <IdleTimerContext.Provider value={value}>
      {children}
      <Modal isOpen={showModal}>
        <Modal.Header>Still connected?</Modal.Header>
        <Modal.Body>
          Time remaining: {Math.ceil(timeRemaining / 1000)} seconds           
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleStayActive}>Continue</Button>
          <Button className="ms-2" onClick={handleLogout}>Logout</Button>           
        </Modal.Footer>
      </Modal>
    </IdleTimerContext.Provider>
  );
};